//WhistleBlowArchiveWhistleBlowList
//***********************************************************************************************************************
import * as React from "react";
import * as whistleBlowService from "../../../models/services/whistleBlowService";
import { Translations } from "ui/Scripts/source/models/translations";
import { List } from "../../framework/List/List";
import { AppUtils } from "../../../framework/appUtils";
import { Base } from "ui/Scripts/source/framework/base";
import { IWhistleBlowListItem } from "ui/Scripts/source/models/whistleBlow/whistleBlowListItem";
import { WhistleBlowListStateCol } from "../WhistleBlowList";
import { WhistleBlowState } from "ui/Scripts/source/models/enums";
import { IWhistleBlowPageFilterState, WhistleBlowPageDashboardChart } from "../WhistleBlowPageDashboardChart";

//WhistleBlowArchiveWhistleBlowList
export interface IWhistleBlowArchiveWhistleBlowListProps extends IWhistleBlowPageFilterState {
    classes?: string;
    companyId: string;
    selectedId?: string;
    checkedIds?: string[];
    dataId?: string;
    sortColumn?: string;
    sortOrderIsAsc?: boolean;
    onSetSelectedIds?: (selectedId: string, checkedIds: string[]) => void;
    onSetSortData?: (sortColumn: string, sortOrderIsAsc: boolean) => void;
}

export interface IWhistleBlowArchiveWhistleBlowListState {
    //List
    intialized: boolean;
    isLoading: boolean;
    pageSize: number;
    page: number;
    hasMore: boolean;
    sortColumn: string;
    sortOrderIsAsc: boolean;
    items: IWhistleBlowListItem[];
}

export class WhistleBlowArchiveWhistleBlowList extends React.Component<IWhistleBlowArchiveWhistleBlowListProps, IWhistleBlowArchiveWhistleBlowListState> {
    constructor(props: IWhistleBlowArchiveWhistleBlowListProps) {
        super(props);
        this.state = {
            //List
            intialized: false,
            isLoading: false,
            pageSize: 10000,
            page: 1,
            hasMore: true,
            sortColumn: props.sortColumn ? props.sortColumn : "state",
            sortOrderIsAsc: props.sortColumn ? props.sortOrderIsAsc : true,
            items: []
        };
    }

    searchItems = async (pageSize: number, page: number, sortColumn: string, sortOrderIsAsc: boolean, resetItems: boolean, refreshList: boolean, initialLoad: boolean = false) => {
        const props = this.props;
        const state = this.state;
        this.setState({ isLoading: true });
        const severity = !Base.isNullOrUndefined(props.selectedSeverityFilterId) ? parseInt(props.selectedSeverityFilterId, 10) : null;
        const resolution = !Base.isNullOrUndefined(props.selectedResolutionFilterId) ? parseInt(props.selectedResolutionFilterId, 10) : null;
        const source = !Base.isNullOrUndefined(props.selectedSourceFilterId) ? parseInt(props.selectedSourceFilterId, 10) : null;
        const anonymity = !Base.isNullOrUndefined(props.selectedAnonymityFilterId) ? parseInt(props.selectedAnonymityFilterId, 10) : null;
        const dynamicTime = !Base.isNullOrUndefined(props.selectedDynamicTimeFilterId) ? parseInt(props.selectedDynamicTimeFilterId, 10) : 0;
        const result = await AppUtils.callService(() => whistleBlowService.getWhistleBlowListItems(this.props.companyId, !refreshList ? pageSize : (page * pageSize), !refreshList ? page : 1, null,
            props.selectedStartDate, props.selectedEndDate, props.selectedUnitIds.filter(i => i !== Base.emptyGuid), props.selectedCategoryIds.filter(i => i !== Base.emptyGuid),
            props.selectedHandlerUserCodes.filter(i => !!i), WhistleBlowState.Resolved,
            severity, resolution, source, anonymity, dynamicTime, sortColumn, sortOrderIsAsc), false, false, () => this.setState({ isLoading: false }));
        if (!result) return;
        const items = List.getListItems(state.items, props.selectedId ?? "", props.checkedIds ?? [], result.items, resetItems, refreshList);
        this.setState({
            intialized: true,
            page: !refreshList ? result.page : page,
            hasMore: result.hasMore,
            sortColumn,
            sortOrderIsAsc,
            items: items.items
        });
        if (props.onSetSelectedIds) {
            props.onSetSelectedIds(items.selectedId, !initialLoad ? items.checkedIds : items.items.map(i => i.id));
        }
    };

    componentDidMount(): void {
        const state = this.state;
        this.searchItems(state.pageSize, 1, state.sortColumn, state.sortOrderIsAsc, true, false, true);
    }

    componentDidUpdate(prevProps: IWhistleBlowArchiveWhistleBlowListProps, prevState: IWhistleBlowArchiveWhistleBlowListState) {
        const props = this.props;
        const state = this.state;
        const prevDataId = prevProps.dataId ? prevProps.dataId : "";
        const dataId = props.dataId ? props.dataId : "";
        const prevCompanyId = prevProps.companyId ? prevProps.companyId : "";
        const companyId = props.companyId ? props.companyId : "";
        const filterStateChange = WhistleBlowPageDashboardChart.getWhistleBlowGeneralFilterChange(prevProps, props);
        const prevSortColumn = prevProps.sortColumn ? prevProps.sortColumn : state.sortColumn;
        const sortColumn = props.sortColumn ? props.sortColumn : state.sortColumn;
        const prevSortOrderIsAsc = prevProps.sortColumn ? prevProps.sortOrderIsAsc : state.sortOrderIsAsc;
        const sortOrderIsAsc = props.sortColumn ? props.sortOrderIsAsc : state.sortOrderIsAsc;
        if (dataId === prevDataId && companyId === prevCompanyId &&
            filterStateChange.notChanged &&
            prevSortColumn === sortColumn && prevSortOrderIsAsc === sortOrderIsAsc) return;
        this.searchItems(state.pageSize, 1, sortColumn, sortOrderIsAsc, true, false, true);
    }

    handleSearchLinesDialog = (sortColumn: string, sortOrderIsAsc: boolean, nextPage: boolean) => {
        const state = this.state;
        this.searchItems(state.pageSize, !nextPage ? 1 : state.page + 1, sortColumn, sortOrderIsAsc, !nextPage, false);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <List
                multiSelect={true}
                intialized={state.intialized}
                isLoading={state.isLoading}
                hasMore={state.hasMore}
                height="400px"
                header={{
                    columns: [
                        { size: 2, column: "unitCode", content: Translations.Unit },
                        { size: 2, column: "code", content: Translations.Code },
                        { size: 1, column: "date", content: Translations.WhistleBlowDateAndTime },
                        { size: 2, column: "", content: Translations.Title },
                        { size: 2, column: "state", content: Translations.State },
                        //{ size: 2, column: "", content: Translations.Handlers },
                        { size: 2, column: "category", content: Translations.Category },
                        { size: 1, column: "severity", content: Translations.Severity }
                    ],
                    defaultChecked: true
                }}
                lines={
                    state.items.map((item) => {
                        return {
                            columns: [
                                { size: 2, content: item.unitCode },
                                {
                                    size: 2,
                                    content:
                                        <div className="codeVal withIcon">
                                            <div>{item.code}</div>
                                            {!item.anonymous &&
                                                <span className="icon person" title={Translations.WhistleBlowNonAnonymousReport}></span>
                                            }
                                        </div>
                                },
                                { size: 1, content: Base.timeToDateTimeStr(item.date) },
                                { size: 2, content: item.title },
                                {
                                    size: 2,
                                    content: <WhistleBlowListStateCol item={item} />
                                },
                                //{
                                //    classes: "col-2 whistleBlowHandlersCol ",
                                //    content: <WhistleBlowListHandlersCol item={item} />
                                //},
                                { size: 2, content: item.categoryCode },
                                { size: 1, content: item.severityStr }
                            ],
                            id: item.id
                        };
                    })
                }
                sortColumn={state.sortColumn}
                sortOrderIsAsc={state.sortOrderIsAsc}
                selectedId={props.selectedId}
                checkedIds={props.checkedIds}
                onSetSelectedIds={props.onSetSelectedIds}
                onSearchLines={this.handleSearchLinesDialog}
            />
        );
    }
}